import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link as RouterLink } from "react-router-dom";

const jobs = [
  {
    title: "Freshers",
    description:
      "We are looking for passionate fresh graduates eager to start their career in software development, testing, data, or enterprise technologies.",
  },
  {
    title: "Full Stack Developers",
    description:
      "Experience in React, Node.js / Django, REST APIs, databases, and cloud-native development.",
  },
  {
    title: ".Net Developers",
    description:
      "Strong experience with C#, ASP.NET Core, Web APIs, SQL Server, and enterprise application development.",
  },
  {
    title: "MSBI Developers",
    description:
      "Expertise in SSIS, SSRS, SSAS, data warehousing, and reporting solutions.",
  },
  {
    title: "SharePoint Developers",
    description:
      "Hands-on experience with SharePoint Online, SPFx, Power Platform, and enterprise collaboration tools.",
  },
  {
    title: "Scrum Masters",
    description:
      "Certified Scrum Masters with experience in Agile delivery, sprint planning, and stakeholder coordination.",
  },
  {
    title: "Automation Test Engineers",
    description:
      "Experience with Selenium, Cypress, Playwright, API automation, and CI/CD pipelines.",
  },
  {
    title: "ETL Testing / Big Data",
    description:
      "Knowledge of ETL processes, data validation, Hadoop ecosystem, and large-scale data testing.",
  },
  {
    title: "SAP (MM, PP, SD, FICO)",
    description:
      "Functional consultants with hands-on SAP implementation and support experience.",
  },
  {
    title: "ROR Developers",
    description:
      "Ruby on Rails developers with experience in scalable web applications and RESTful services.",
  },
];


export default function Careers() {
  return (
    <Box sx={{ backgroundColor: "#1f2937", minHeight: "100vh", color: "#fff" }}>
      <Container sx={{ py: 8 }}>
        <Typography variant="h4" fontWeight={600} gutterBottom>
          Careers
        </Typography>

        <Divider sx={{ mb: 4, borderColor: "#374151" }} />

        {jobs.map((job, index) => (
          <Accordion
            key={index}
            sx={{
              backgroundColor: "#1f2937",
              color: "#fff",
              boxShadow: "none",
              borderBottom: "1px solid #374151",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#9ca3af" }} />}
            >
              <Typography variant="h6">{job.title}</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography sx={{ opacity: 0.85, mb: 2 }}>
                {job.description}
              </Typography>


                <Button
                    component={RouterLink}
                    to="/careers/apply"
                    sx={{
                        backgroundColor: "#ff0080",
                        color: "#fff",
                        textTransform: "none",
                        px: 3,
                        borderRadius: 5,
                        "&:hover": {
                        backgroundColor: "#ff2d8d",
                        },
                    }}
                    >
                    Apply Now
                    </Button>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
}
